export default "__VITE_ASSET__CJE_E8Pv__"